import { Blocks, PawPrint, Plus } from "lucide-react";

export default function AdminBatchSections({
  onAddContent,
  onShowAllContent,

  onAddHomework,
  onShowAllHomework,

  onAddSession,
  onShowAllSessions,
onEnrollStudent,
  onShowStudents
}) {

  return (
    <div
      style={{ padding:"5px",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))",
        gap: 14
      }}
    >

      <SectionCard
        title="Content Drip"
        description="Lessons, videos, folders, quizzes"
        onAdd={()=>onAddContent("addContentRoute")}
        hideEnroll
        onShowAll={onShowAllContent}
      />
 <SectionCard
        title="Students"
        description="Enrolled learners"
        hideAdd 
         onEnroll={onEnrollStudent}
        onShowAll={onShowStudents}
      />
      <SectionCard
        title="Homework"
        description="Assignments for this batch"
        onAdd={onAddHomework}
        hideEnroll
        onShowAll={onShowAllHomework}
      />

      {/* <SectionCard
        title="Sessions "
        description="Live / scheduled classes"
        onAdd={onAddSession}
        hideEnroll
        onShowAll={onShowAllSessions}
      />
<SectionCard
        title="Teachers"
        description="Add co-teachers , instructors or staff roles"
        hideAdd 
         onEnroll={onEnrollStudent}
        onShowAll={onShowStudents}
      /> */}
      {/* <SectionCard
        title="Leaderboard"
        description="Enrolled learners"
        hideAdd 
         onEnroll={onEnrollStudent}
        onShowAll={onShowStudents}
      /> */}
       {/* <SectionCard
        title="Attendance"
        description=""
        onAdd={onAddSession}
        hideEnroll
        onShowAll={onShowAllSessions}
      />
  <SectionCard
        title="Notification"
        description=""
        onAdd={onAddSession}
        hideEnroll
        onShowAll={onShowAllSessions}
      /> */}

    </div>
  );
}

/* ---------------------------------- */

function SectionCard({
  title,
  description,
  onAdd,onEnroll,
  onShowAll,
  hideAdd,hideEnroll
}) {

  return (
    <div
      style={{
        
        borderRadius: 8,
        padding: 14,
        background: "#f9f9f9",position:"relative",zIndex:99
      }}
    >
      <div style={{ fontWeight: 600 }}>
        {title}
      </div>

      <div
        style={{
          fontSize: 12,
          color: "#666",
          marginTop: 4,
          marginBottom: 12
        }}
      >
        {description}
      </div>

      <div
        style={{
          display: "flex",justifyContent:"space-between",
          gap: 8,
          flexWrap: "wrap"
        }}
      >
        {!hideAdd && (
          <button style={{width:"80px",position:"relative",fontSize:"16px",border:"2px solid rgba(144, 202, 249,1)",background:"#ffffff",color:"#222",
        padding:"5px 10px" ,borderRadius:"5px",cursor:"pointer",zIndex:"9",display:"flex",justifyContent:"justify-content",gap:"5px",alignItems:"center"}} 
        onClick={onAdd}>
          <Plus size={16} color="#222222" /><span> Add</span>
          </button>
        )}
      {!hideEnroll && (
          <button style={{width:"90px",position:"relative",fontSize:"16px",border:"2px solid rgba(144, 202, 249,1)",background:"#ffffff",color:"#222",
        padding:"5px 10px" ,borderRadius:"5px",cursor:"pointer",zIndex:"9",display:"flex",justifyContent:"justify-content",gap:"5px",alignItems:"center"}} 
        onClick={onEnroll}>
        <PawPrint size={16} color="#222222" />  <span> Enroll</span>
          </button>
        )}

        <button  style={{width:"120px",position:"relative",fontSize:"16px",border:"2px solid rgb(249, 201, 199)",background:"#ffffff",
        color:"#222",
        padding:"5px 10px" ,borderRadius:"5px",cursor:"pointer",zIndex:"9",display:"flex",justifyContent:"justify-content",gap:"5px",alignItems:"center"}} 
       onClick={onShowAll}>
        <Blocks size={16} color="#222222" /> <span> Show all</span>
        </button>
      </div>
    </div>
  );
}
